import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Privacidad() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f5f1ea] min-h-screen text-[#141414]">
      <header className="border-b border-[#141414]/10 bg-[#f5f1ea] sticky top-0 z-40">
        <div className="w-full px-6 md:px-12 lg:px-20 h-[64px] flex items-center justify-between">
          <button onClick={() => navigate('/')} className="inline-flex items-center gap-2 text-[#141414]/60 hover:text-[#141414] text-[13.5px] transition-colors">
            <ArrowLeft size={15} /> Volver
          </button>
          <a href="/" className="flex items-center gap-2">
            <svg width="20" height="20" viewBox="0 0 26 26" fill="none" className="text-[#141414]"><path d="M2 4 L13 22 L24 4 L19 4 L13 14 L7 4 Z" fill="currentColor" /></svg>
            <span className="font-serif text-[18px] tracking-tight">Escalado</span>
          </a>
        </div>
      </header>

      <main className="w-full px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="max-w-[780px]">
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#141414]/45 mb-5">Legal</p>
          <h1 className="font-serif text-[36px] md:text-[48px] leading-[1.06] tracking-[-0.02em] mb-12">Política de Privacidad</h1>

          <div className="space-y-10 text-[#141414]/80 text-[15.5px] leading-[1.75]">

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">1. Responsable del tratamiento</h2>
              <div className="bg-[#ece6db] p-6 space-y-2 text-[14.5px]">
                <p><span className="font-medium text-[#141414]">Responsable:</span> Zeus Digital Business Ltd</p>
                <p><span className="font-medium text-[#141414]">Sede principal:</span> Covent Garden, 73, Londres, Reino Unido</p>
                <p><span className="font-medium text-[#141414]">Oficina España:</span> C/ de les Barques, 2, 2ª planta, Ciutat Vella, 46002 Valencia</p>
                <p><span className="font-medium text-[#141414]">Email:</span> privacidad@escalado.com</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">2. Datos que recopilamos</h2>
              <p>A través de los formularios disponibles en el Sitio Web, podemos recopilar:</p>
              <ul className="space-y-2 pl-5 border-l-2 border-[#141414]/15">
                <li><strong>Identificación:</strong> nombre y apellidos.</li>
                <li><strong>Contacto:</strong> correo electrónico.</li>
                <li><strong>Profesionales:</strong> empresa y sector de actividad.</li>
                <li><strong>Navegación:</strong> IP, navegador y páginas visitadas (con cookies analíticas, previo consentimiento).</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">3. Finalidad del tratamiento</h2>
              <ul className="space-y-2 pl-5 border-l-2 border-[#141414]/15">
                <li><strong>Gestión de solicitudes:</strong> atender diagnósticos o consultas recibidas a través del formulario.</li>
                <li><strong>Comunicaciones comerciales:</strong> enviarte información sobre nuestros servicios, con tu consentimiento previo.</li>
                <li><strong>Mejora del servicio:</strong> analizar el uso del Sitio Web para optimizar la experiencia del usuario.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">4. Base jurídica</h2>
              <ul className="space-y-2 pl-5 border-l-2 border-[#141414]/15">
                <li><strong>Consentimiento</strong> (Art. 6.1.a RGPD): para comunicaciones y cookies no esenciales.</li>
                <li><strong>Ejecución de contrato</strong> (Art. 6.1.b RGPD): para gestionar solicitudes de diagnóstico.</li>
                <li><strong>Interés legítimo</strong> (Art. 6.1.f RGPD): para el mantenimiento y seguridad del Sitio Web.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">5. Conservación de datos</h2>
              <p>Conservaremos tus datos durante el tiempo necesario para cumplir con la finalidad para la que fueron recabados. Los datos del formulario de contacto se conservan un máximo de <strong>24 meses</strong> desde el último contacto, salvo solicitud de supresión anterior.</p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">6. Comunicación a terceros</h2>
              <p>No cedemos tus datos a terceros salvo obligación legal o necesidad para la prestación del servicio (proveedores de correo o CRM con los que se hayan firmado los acuerdos de tratamiento correspondientes). Las transferencias fuera del EEE se realizan con garantías adecuadas conforme al RGPD.</p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">7. Tus derechos</h2>
              <p>Puedes ejercer los derechos de <strong>acceso, rectificación, supresión, oposición, limitación y portabilidad</strong> enviando un correo a <strong>privacidad@escalado.com</strong> con copia de tu documento de identidad. También puedes reclamar ante la <strong>AEPD</strong> en <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">www.aepd.es</a>.</p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">8. Seguridad</h2>
              <p>Zeus Digital Business Ltd aplica medidas técnicas y organizativas apropiadas para garantizar la seguridad e integridad de los datos personales y prevenir accesos no autorizados.</p>
            </section>

            <div className="border-t border-[#141414]/10 pt-8">
              <p className="text-[13px] text-[#141414]/45">Última actualización: mayo de 2026.</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
